/**
 * HomePage Configuration Constants
 * Contains all static configuration data for the homepage including new apps configuration
 */

import InventoryIcon from "@mui/icons-material/Inventory";
import EmailIcon from "@mui/icons-material/Email";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

/**
 * Configuration for external applications displayed on the homepage
 * DEPRECATED: All apps now managed through routes.js with accessRight permissions
 * Kept for backward compatibility - can be removed if not needed elsewhere
 */

export const NEW_APPS_CONFIG = [];

/**
 * Greeting messages based on time of day
 */
export const GREETINGS = {
  MORNING: "בוקר טוב",
  AFTERNOON: "צהריים טובים",
  EVENING: "ערב טוב",
};

/**
 * Time boundaries for greeting messages (in hours, 24-hour format)
 */
export const TIME_BOUNDARIES = {
  AFTERNOON_START: 12,
  EVENING_START: 17,
};

/**
 * Tab values for obligo section
 */
export const OBLIGO_TABS = {
  EXCEPTIONS: 0,
  HISTORY: 1,
};
